import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter020() {
  return <KbChapterPage slug="chapter-020" />;
}

(Chapter020 as unknown as { path: string }).path = "/theory-album/020";
